import { Config } from "../core/config/config.js";
import React from "react";
export class PdfPreview extends React.Component<{ page: number; dokuId: string; textToHighlight: string[]; titel: string; }, any> {
    private iframeElement: HTMLIFrameElement;
    private interval;
    async componentDidUpdate(prevProps) {
        await this.updatePdf();
    }

    async componentDidMount() {
        await this.updatePdf();
    }
    private findStartAndEndPosition = (shortText, longText) => {
        // Funktion zum Extrahieren von Buchstaben
        const getLetters = (text) => text.match(/\p{L}/gu)?.join('') || '';

        // Buchstaben aus beiden Texten holen
        const shortLetters = getLetters(shortText);
        const longLetters = getLetters(longText);

        // Finde die Startposition im bereinigten langen Text
        const startIndexInCleaned = longLetters.indexOf(shortLetters);

        if (startIndexInCleaned === -1) {
            return { start: -1, end: -1 }; // Nicht gefunden
        }

        // Berechne die Endposition im bereinigten langen Text
        const endIndexInCleaned = startIndexInCleaned + shortLetters.length - 1;

        // Finde die Start- und Endposition im Originaltext
        let letterCount = 0;
        let startPosition = -1;
        let endPosition = -1;

        for (let i = 0; i < longText.length; i++) {
            if (/\p{L}/u.test(longText[i])) {
                if (letterCount === startIndexInCleaned) {
                    startPosition = i; // Startposition im Originaltext gefunden
                }
                if (letterCount === endIndexInCleaned) {
                    endPosition = i; // Endposition im Originaltext gefunden
                    break; // Schleife beenden, da beide Positionen gefunden wurden
                }
                letterCount++;
            }
        }

        return { start: startPosition, end: endPosition };
    }

    private async updatePdf() {
        clearInterval(this.interval);
        this.interval = setInterval(() => {
            const pdfApp = this.iframeElement.contentWindow["PDFViewerApplication"];
            if (pdfApp) {
                const pageView = pdfApp.pdfViewer._pages[this.props.page];
                if (pageView && pageView.pdfPage) {
                    if (!!this.props.textToHighlight) {
                        const startPageIndex = this.props.page; // Startseite (Index 0)
                        const numPagesToSearch = 4; // Startseite + 3 Seiten
                        const textToHighlight = this.props.textToHighlight[0];
                        const parts = textToHighlight.split(/[\s.,;:!?-]+/);

                        // Funktion zum Extrahieren des Textes von mehreren Seiten
                        const extractTextFromPages = async (startIndex, numPages) => {
                            let combinedText = "";
                            for (let i = startIndex; i < startIndex + numPages && i < pdfApp.pdfViewer._pages.length; i++) {
                                const pageView = pdfApp.pdfViewer._pages[i];
                                const textContent = await pageView.pdfPage.getTextContent();
                                const pageText = textContent.items.map(item => item.str).join(" ");
                                combinedText += pageText + " ";
                            }
                            return combinedText.trim();
                        };

                        extractTextFromPages(this.props.page - 2, 3).then((text) => {
                            const range = this.findStartAndEndPosition(textToHighlight, text);
                            const toHighlight = text.substring(range.start, range.end);
                            pdfApp.pdfViewer._pages[startPageIndex].eventBus.dispatch("find", {
                                query: toHighlight,
                                highlightAll: false,
                                phraseSearch: true
                            });


                        });
                        this.iframeElement.contentWindow["PDFViewerApplication"].page = this.props.page;
                        clearInterval(this.interval);
                    }
                }
            }
        }, 200);
    }

    render() {
        const encoded = encodeURIComponent(`${Config.baseUrl}Document/Download?id=${this.props.dokuId}`);
        return (
            <div style={{ flex: 1, height: "100%", width: "100%", display: "flex", margin: "5px", flexDirection: "column" }}>
                <div style={{ fontWeight: "bold", backgroundColor: "rgb(249, 249, 250)", borderStyle: "solid", height: "24px", borderRadius: "5px", alignContent: "center", padding: "5px" }}>{this.props.titel}</div>
                <iframe ref={(e) => this.iframeElement = e} style={{ marginTop: "5px", flex: 1 }} src={`${Config.baseUrl}pdfviewer/web/viewer.html?file=${encoded}#page=${this.props.page}`} />
            </div>
        );
    }
}
